import { Injectable } from '@angular/core';

@Injectable()
export class Session {
	public uid: string;
	public type: number;
	public name: string;
	constructor() {
	}
}
